import React from 'react';
import SpeakerPhoneIcon from '@mui/icons-material/SpeakerPhone';
import eventFormatter from '#component/device/event-formatter';
import PreloaderComponent from '#component/preloader';
import { EmptyLogs } from '#component/device/log/empty-log';
import EventDescription from '#component/device/log/event-description';
import LogCard from '#component/general/log-card';
import { LoadingList, StyledList } from './styles';

/**
 * Renders cards with log info.
 * @returns {React.FC}
 */

const MobileView = props => {
  const { account, loading, error, logs } = props;

  if (!logs.length && loading) {
    return <PreloaderComponent />;
  }

  if (error) {
    return <EmptyLogs />;
  }

  const ListComponent = loading ? LoadingList : StyledList;

  return (
    logs.length > 0 ? (
      <ListComponent>
        {logs.map((log, i) => (
          <LogCard
            key={i}
            log={log}
            account={account}
            icon={<SpeakerPhoneIcon />}
            EventDescriptionComponent={EventDescription}
            eventFormatter={eventFormatter}
          />
        ))}
      </ListComponent>
    ) : (
      <EmptyLogs />
    )
  );
};

export default MobileView;
